module.exports = __webpack_public_path__ + "img/LY.c4ad6d61.svg";